<template>
    <div class="insight-tags-search" :class="rootClasses" @click.stop>
        <div class="insight-tags-search--input-wrapper" @click="onWrapperClick">
            <input v-model="query"
                    class="insight-tags-search--input"
                    name="query"
                    :placeholder="inputPlaceholder"
                    ref="input"
                    @focus="checkResultsPanelVisibility"
                    @keyup="checkResultsPanelVisibility">
            <button class="insight-tags-search--clear"
                    type="button"
                    v-if="query"
                    @click="clearQuery">
                <ui-icon symbol="menu-close" size="medium"/>
            </button>
            <div class="insight-tags-search--loader">
                <spinning-loader v-if="isLoading"/>
            </div>
            <simple-btn
                    class="insight-tags-search--search-icon"
                    type="submit">
                <ui-icon symbol="search" size="medium"/>
            </simple-btn>
        </div>
        <transition name="trs-simple-fade" mode="in-out">
            <div class="insight-tags-search--results-panel" v-if="showResults">
                <template v-if="suggestions.length">
                    <div class="insight-tags-search--results-panel-row">
                        <div class="insight-tags-search--results-panel-group"
                                :class="[bemAdd(group.title ? 'has-title' : 'is-flat', 'results-panel-group')]"
                                v-for="(group, index) in suggestions"
                                :key="index">
                            <h4 class="insight-tags-search--results-panel-title u-reset" v-if="group.title">
                                {{ group.title }}
                            </h4>
                            <ul class="u-reset">
                                <li class="insight-tags-search--tag"
                                        :class="[bemAdd('base', 'tag')]"
                                        v-for="tag in group.tags"
                                        :key="tag.id"
                                        @click="setQueryToTagTitle(tag, $event)">
                                    <span class="insight-tags-search--tag-text">
                                        {{ tag.title }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
                <p v-else>
                    {{ noResultsFoundText }}
                </p>
                <simple-btn class="insight-tags-search--panel-close" @click.prevent="hideResultsPanel">
                    <ui-icon symbol="menu-close" size="medium"/>
                </simple-btn>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { add as addEvent, remove as removeEvent } from 'bianco.events';
    import SimpleBtn from '../buttons/simple-btn/simple-btn';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import SpinningLoader from '../loaders/spinning-loader/spinning-loader';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { ESC_KEY } from '../../../util/dom/key-codes';

    export default {
        components: { SpinningLoader, SimpleBtn, UiIcon },
        mixins: [bemMixin('insight-tags-search')],
        props: {
            noResultsFoundText: {
                type: String,
                required: true,
            },
            inputPlaceholder: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                showResults: false,
            };
        },
        computed: {
            ...mapState('insights', ['availableFilters', 'activeFilters', 'isLoading']),
            rootClasses() {
                return [
                    this.bemIf(this.isLoading, 'is-loading'),
                ];
            },
            suggestions() {
                return this.availableFilters.suggestions;
            },
            query: {
                get() {
                    return this.activeFilters.query || '';
                },
                set(query) {
                    this.setQuery({ query });
                },
            },
        },
        methods: {
            ...mapActions('insights', ['setQuery']),
            onWrapperClick() {
                this.$refs.input.focus();
            },
            clearQuery(event) {
                event.stopPropagation();
                this.query = '';
                this.submitRequest(event);
            },
            hideResultsPanel() {
                this.showResults = false;
            },
            submitRequest(event) {
                // defer this event in order to allow vue rendering the hidden input
                this.$nextTick(() => {
                    this.$emit('submit-requested', event);
                });
            },
            checkResultsPanelVisibility() {
                this.showResults = !this.query;
            },
            onKeyPress({ keyCode }) {
                if (keyCode === ESC_KEY) {
                    this.hideResultsPanel();
                }
            },
            setQueryToTagTitle(tag, event) {
                this.query = tag.title;
                this.checkResultsPanelVisibility();

                this.submitRequest(event);
            },
        },
        mounted() {
            // detect the click outside
            // notice that the root of this tag doesn't propagate the click events
            addEvent(window, 'click', this.hideResultsPanel);
            addEvent(window, 'keyup', this.onKeyPress);
        },
        beforeDestroy() {
            removeEvent(window, 'click', this.hideResultsPanel);
            removeEvent(window, 'keyup', this.onKeyPress);
        },
    };
</script>
